export default __webpack_public_path__ + "static/media/email_img.98f6956f.png";